export class CampaignUtils {
  static getStatusColor(status: string) {
    switch (status) {
      case "Pending":
        return "text-warning";
      case "Active":
        return "text-success";
      case "Cancelled":
        return "text-gray";
      case "Completed":
        return "text-indigo";
      case "Awaiting Payment":
        return "text-orange";
      default:
        return "text-black";
    }
  }
}
